(function () {
  'use strict';
  const c = window.StoreExperimentConfig;
  if (!c) return;
  const key = 'store-exp:' + c.store + ':' + c.id + ':' + c.revision;
  let assignment = null, exposed = false, busy = null;
  const previewVariant = new URLSearchParams(location.search).get('tsd_ab_preview');
  const previews = c.mode === 'preview' || ['A','B'].includes(previewVariant);
  const safePath = () => location.pathname.slice(0, 250);
  const uuid = () => crypto.randomUUID();
  function read(storage, name) { try { return JSON.parse(storage.getItem(name)); } catch (_) { return null; } }
  function write(storage, name, value) { try { storage.setItem(name, JSON.stringify(value)); return true; } catch (_) { return false; } }
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  function choose() {
    if (assignment) return assignment;
    if (previews) {
      const force = previewVariant || new URLSearchParams(location.search).get('exp_variant');
      let saved = read(sessionStorage, key + ':qa');
      if (force === 'A' || force === 'B') saved = {variant: force, visitor: uuid(), qa: true};
      assignment = saved || {variant: 'B', visitor: uuid(), qa: true};
      write(sessionStorage, key + ':qa', assignment);
      return assignment;
    }
    if (!c.enabled || !c.collector || !allowed()) return null;
    const now = Date.now();
    if (!(now >= Date.parse(c.start) && now < Date.parse(c.end) + (c.followupDays||7)*86400000)) return null;
    let saved = read(localStorage, key);
    if(now>=Date.parse(c.end) && !saved?.exposedAt)return null;
    if (!saved || !['A','B'].includes(saved.variant) || !/^[0-9a-f-]{36}$/i.test(saved.visitor)) {
      // One unbiased bit; 50% chance, not an exact quota for small samples.
      saved = {variant: (crypto.getRandomValues(new Uint32Array(1))[0] & 1) ? 'B' : 'A', visitor: uuid(), at: new Date().toISOString()};
      if (!write(localStorage, key, saved)) return null;
    }
    assignment = saved;
    return assignment;
  }
  function payload(type, page) {
    return {eventId: uuid(), store: c.store, experiment: c.id, revision: c.revision,
      visitor: assignment.visitor, variant: assignment.variant, type, path: page || safePath(), occurredAt:new Date().toISOString()};
  }
  async function send(type) {
    if (previews || !assignment || !allowed()) return false;
    try {
      if(!assignment.pendingEvent) {assignment.pendingEvent=payload(type);write(localStorage,key,assignment);}
      const r = await fetch(c.collector + '/events', {method:'POST', mode:'cors', credentials:'omit',
        headers:{'Content-Type':'text/plain'}, body:JSON.stringify(assignment.pendingEvent), keepalive:true});
      if(r.ok){delete assignment.pendingEvent;write(localStorage,key,assignment);}
      return r.ok;
    } catch (_) { return false; }
  }
  function attributes(clear) {
    const suffix = c.id.replace(/[^a-z0-9-]/gi,'');
    return {['__experiment_' + suffix]: clear ? '' : JSON.stringify({id:c.id, revision:c.revision,
      visitor:assignment.visitor, variant:assignment.variant, exposedAt:assignment.exposedAt, path:assignment.path, lastPricePage:assignment.lastPricePage})};
  }
  function annotateForms(clear) {
    if (previews || !assignment) return;
    const name='properties[_experiment_'+c.id+']';
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{
      let input=Array.from(form.querySelectorAll('input')).find(e=>e.name===name);
      if(clear){input?.remove();return;}
      if(!input){input=document.createElement('input');input.type='hidden';input.name=name;form.append(input);}
      input.value=Object.values(attributes(false))[0];
    });
  }
  async function syncCart(clear) {
    if (previews || !assignment) return true;
    if (!clear && !allowed()) return false;
    try {
      const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
        method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({attributes:attributes(clear)})});
      return r.ok;
    } catch (_) { return false; }
  }
  async function clearLineAttribution() {
    const base=window.Shopify?.routes?.root || '/';
    try {
      const response=await fetch(base+'cart.js',{credentials:'same-origin'});
      if(!response.ok)return;
      const cart=await response.json();
      for(const item of cart.items || []) {
        const name='_experiment_'+c.id;
        if(!item.properties?.[name])continue;
        // Preserve all customer properties and quantity; clear only this experiment.
        await fetch(base+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:item.key,properties:{...item.properties,[name]:''}})});
      }
    } catch (_) {}
  }
  async function exposure() {
    if (previews || exposed || !assignment || !allowed()) return;
    if(Date.now()>=Date.parse(c.end)+(c.followupDays||7)*86400000)return;
    if(Date.now()>=Date.parse(c.end) && !assignment.pendingEvent) {await syncCart(false);return;}
    if (busy) return busy;
    busy = (async () => {
      const first = !assignment.exposedAt;
      if (first) { assignment.exposedAt = new Date().toISOString(); assignment.path = safePath(); write(localStorage,key,assignment); }
      assignment.lastPricePage=safePath();write(localStorage,key,assignment);
      annotateForms(false);
      const recorded = await send('exposure');
      if (recorded) {
        exposed = true;
        await syncCart(false);
        // No personal data. Optional bridge for an existing GA4 tag, not the authoritative denominator.
        window.dataLayer?.push({event:'experiment_exposure', experiment_id:c.id,
          experiment_variant:assignment.variant, experiment_store:c.store});
      }
      busy = null;
      if(!recorded&&allowed()) setTimeout(exposure,10000);
    })();
    return busy;
  }
  let observed = new WeakSet();
  function formatPrice(el, cents, years, money, currency, isOnce, cadence) {
    const a = choose();
    const eligible = Number.isFinite(cents) && cents > 0 && Number.isFinite(years) && years > 0 && currency === 'USD';
    let sub = el.closest('.tsd-simple-total')?.querySelector('.tsd-billed-total');
    if (!sub) return;
    const weekly = eligible && a?.variant === 'B';
    el.textContent = weekly ? money(Math.round(cents / (52 * years))) : money(cents);
    if (weekly) { const unit=document.createElement('span');unit.className='tsd-week-unit';unit.textContent='/week';el.append(unit); }
    sub.hidden = !weekly;
    sub.textContent = 'Billed as ' + money(cents) + (isOnce ? ' once' : ' ' + (cadence || (years === 1 ? 'annually' : 'every ' + years + ' years')));
    if(eligible)el.setAttribute('aria-label', weekly ? el.textContent + ' equivalent. ' + sub.textContent : money(cents) + ' for ' + years + ' years');
    const compare=el.closest('.tsd-simple-total').querySelector('.tsd-simple-compare-at');
    if (compare) {
      if (!compare.dataset.total) compare.dataset.total=compare.textContent;
      // Native sync sets the original total each time; convert only the displayed benchmark.
      const raw=Number(compare.textContent.replace(/[^0-9.]/g,''));
      if (weekly && Number.isFinite(raw)) {
        compare.textContent=money(Math.round(raw*100/(52*years)))+'/week';
        compare.setAttribute('aria-label','Typical weekly equivalent for the same term');
      }
    }
    if (eligible && a && !previews && !observed.has(el)) {
      observed.add(el);
      const observer=new IntersectionObserver(entries=>{
        if(entries.some(e=>e.isIntersecting&&e.intersectionRatio>=0.5)){exposure();observer.disconnect();}
      },{threshold:0.5});observer.observe(el);
    }
  }
  // Assign the initial checkbox state only; subsequent shopper choices stay intact.
  const toggleStates = new WeakMap();
  function applyToggle(toggle, price, eligible) {
    if (!eligible) return;
    let state = toggleStates.get(toggle);
    if (!state) {
      state = {assigned:false, touched:false};
      toggleStates.set(toggle,state);
      toggle.addEventListener('change',()=>{state.touched=true;});
    }
    const a = choose();
    if (!a) return;
    if (!state.assigned) {
      if (!state.touched) toggle.checked = a.variant === 'B';
      state.assigned = true;
    }
    if (!previews && !observed.has(price)) {
      observed.add(price);
      const observer = new IntersectionObserver(entries=>{
        if(entries.some(e=>e.isIntersecting&&e.intersectionRatio>=0.5)){exposure();observer.disconnect();}
      },{threshold:0.5});
      observer.observe(price);
    }
  }
  window.StoreExperiment = {formatPrice, applyToggle, getAssignment:()=>choose(), retry:exposure};
  choose();
  if (!previews && c.enabled && !window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{
      if(!error) document.querySelectorAll('.bsub-widget').forEach(w=>w.dispatchEvent(new Event('change')));
    });
  }
  document.addEventListener('visitorConsentCollected', async () => {
    if (!previews && !allowed()) {
      if (assignment) await syncCart(true);
      annotateForms(true);
      if(assignment) await clearLineAttribution();
      try { localStorage.removeItem(key); } catch (_) {}
      assignment = null; exposed = false;
      observed = new WeakSet();
    }
    // Recompute using the native widget sync; don't change selling-plan selection.
    document.querySelectorAll('.bsub-widget').forEach(w => w.dispatchEvent(new Event('change')));
  });
  // Persist attributes as soon as the exposure is recorded; retry after an add-to-cart.
  // Avoid blocking checkout or patching fetch; an attribution outage must not break purchases.
  document.addEventListener('cart:update',()=>syncCart(false));
  document.addEventListener('submit',()=>{if(assignment?.exposedAt&&allowed())annotateForms(false);},true);
  window.addEventListener('online',()=>{if(assignment){exposure();syncCart(false);}});
})();
